import { useDocumentOverflowLockedEffect as a } from "./document-overflow/use-document-overflow.js";
import { useIsTopLayer as x } from "./use-is-top-layer.js";
function f(e, c, n = () => [document.body]) {
  let r = x(e, "scroll-lock");
  a(r, c, (t) => {
    var o;
    return { containers: [...(o = t.containers) != null ? o : [], n] };
  });
}
export {
  f as useScrollLock
};
